import "./ConfirmCompleteTask.scss";

function ConfirmCompleteTask({ incompleteCount, onConfirm, onCancel }) {
  return (
    <div className="confirm-complete-task-content">
      <div className="modal-title">
        <div>Incomplete Subtasks</div>
      </div>
      <div className="modal-body">
        <p>
          This task has {incompleteCount} incomplete subtask
          {incompleteCount > 1 ? "s" : ""}. Are you sure you want to mark it as
          complete?
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={onCancel}>
          Cancel
        </button>
        <button className="modal-button confirm" onClick={onConfirm}>
          Mark Complete
        </button>
      </div>
    </div>
  );
}

export default ConfirmCompleteTask;
